// extracted by mini-css-extract-plugin
export default {"container":"PlatformLayout_container__ZKM9i","container__content":"PlatformLayout_container__content__+d-oy","outlet":"PlatformLayout_outlet__Zwdhq"};